import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiStatsV2ReservationDailyElFindParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiStatsV2ReservationDailyElFindParams, unknown>

const fetchStatsReservationDaily = async (params: ApiStatsV2ReservationDailyElFindParams) => {
  const { data } = await apiClient.v2.apiStatsV2ReservationDailyElFind(params);
  return checkApiResponse(data);
}

export const statsReservationDailyKeys = {
  all: [QUERY_KEY.v2apiStatsV2ReservationDailyElFind] as const,
  list: (params: ApiStatsV2ReservationDailyElFindParams) => [...statsReservationDailyKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(statsV2ReservationDailyFindQueryOptions(params))` */
export const statsV2ReservationDailyFindQueryOptions = (params: ApiStatsV2ReservationDailyElFindParams) => ({
  queryKey: statsReservationDailyKeys.list(params),
  queryFn: () => fetchStatsReservationDaily(params),
  // 날짜별 데이터 — FCM invalidation(타 사용자 변경)과 mutation invalidation(내 변경)이 커버하므로 5분 캐시
  staleTime: 5 * 60 * 1000,
  gcTime: 5 * 60 * 1000,
})

export const useStatsV2ReservationDailyFindQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: statsReservationDailyKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchStatsReservationDaily(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
